<template>
    <div v-redirect-if-no-permission:SERVICES>
        <DataTable :url="api.ACTIONS.SERVICES"
                   :fieldsHiddenMain='["deleted_at","active_price", "start_time", "end_time"]'
                   :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id","active_price", "start_time", "end_time"]'
                   :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id","active_price", "start_time", "end_time"]'
                   :formatter="formatter"
                   :actionsExtraMain="actionsExtraMain"
                   :fields-extra-add="extraEditor"
                   :fields-extra-edit="extraEditor"
                   :add-rules="rules(true)"
                   :edit-rules="rules(false)"
                   :titles="titles"
                   title="Services"/>
    </div>
</template>

<script>

    import DataTable from "@/components/wasilni/DataTable";

    const number = value => {
        const pattern = /^\d+$/;
        if (!!value)
            return pattern.test(value) || "Must be number";
        else
            return true;
    };
    const required = value => !!value || 'This Field Is Required';

    export default {
        components: {DataTable},
        name: "Services",
        title: 'Services',
        methods: {
            rules(add) {
                return {
                    max_bookings: [
                        number
                    ],
                    priority: add ? [
                        required, number
                    ] : [number],
                    name: add ? [
                        required
                    ] : [],
                    icon: add ? [
                        required
                    ] : []
                }
            },
        },
        computed: {

            extraEditor() {
                return {
                    icon: 'choose-image-single',
                    is_pooling: 'v-checkbox',
                    appearance_constrain: 'choose-appearance-constrain'
                }
            },
            formatter() {
                const api = this.api;
                return {
                    icon(value) {
                        if (value == null) return "Un-loadable";
                        if (value[0] !== '/') value = "/" + value;
                        return `<img src="${api.IMAGES_URL + value}" class="img-thumbnail"/>`;
                    },
                    is_pooling(value) {
                        if (value) {
                            return 'Yes';
                        }
                        return 'No';
                    }
                }
            },
            titles() {
                return {
                    "id": "#",
                    "max_bookings": "Maximum Number Of bookings",
                    "created_at": "Date Created",
                    "updated_at": "Date Updated",
                    "appearance_constrain": "Appearance Constrain"
                }
            },
            actionsExtraMain() {
                return {

                    prices: {
                        icon: 'attach_money',
                        extras: {
                            color: '#85bb65'
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "ServicePrices",
                                params: {"id": item.id},
                                query: {"name": item.name}
                            })
                    },
                    captains: {
                        icon: 'directions_car',
                        extras: {
                            color: 'red'
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "ServiceCars",
                                params: {"id": item.id},
                                query: {"name": item.name}
                            })
                    },
                    locations: {
                        icon: 'location_on',
                        extras: {
                            color: "#8695bf"
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "ServiceLocations",
                                params: {"id": item.id},
                                query: {"name": item.name, appearance_constrain: item.appearance_constrain}
                            })
                    },
                }
            }
        }
    }
</script>

<style>
    .img-thumbnail {
        max-height: 40px;
        max-width: 40px;
    }
</style>